import { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { useLocation, useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';
import { addliveLessons, deleteLiveLessons, getliveLessons, isOpenModal, ModalToggle, updateliveLessons, } from '../../store/liveLessonsSlice';
import moment from 'moment/moment';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { service } from '../../shared/_services/api_service';

const LiveLessonsTable = () => {
  const storeVar = useSelector(state => state.liveLesson)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { layoutURL } = useContext(CustomizerContext);
  const toggle = () => dispatch(ModalToggle());
  const [mainId, setmainId] = useState()
  const [submit, setSubmit] = useState(false);
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 30,
    offset: 0,
    currentPage: 1,
    modalTitle: null,
    editState: false,
    lessonId: '',
    title: '',
    livePrice: '',
    examPrice: '',
    publishDate: '',
    duration: "",
    liveRecordUrl: "",
    liveStatus: ''
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id") || "";
    setmainId(id);

    dispatch(getliveLessons(formVar.limit, formVar.offset, id))
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getliveLessons(formVar.limit, offset, mainId))
  };

  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      lessonId: data._id,
      modalTitle: 'Edit Live Lessons',
      title: data.title,
      livePrice: data.livePrice,
      examPrice: data.examPrice,
      publishDate: data.liveDate,
      duration: data.duration,
      liveStatus: data.liveStatus,
      liveRecordUrl: data.liveRecordUrl,
    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Live Lessons',
      title: '',
    }))
  }
  const submitMenu = () => {
    if (titleValid() || publishValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    if (formVar.editState) {
      dispatch(updateliveLessons(formVar.lessonId, { title: formVar.title, liveDate: formVar.publishDate, livePrice: formVar.livePrice, examPrice: formVar.examPrice, duration: parseInt(formVar.duration),liveRecordUrl: formVar.liveRecordUrl }))
    } else {
      dispatch(addliveLessons({ liveChapterId: mainId, title: formVar.title, liveDate: formVar.publishDate, livePrice: formVar.livePrice, examPrice: formVar.examPrice, duration: parseInt(formVar.duration) }))
    }
  }


  const titleValid = () => {
    if (!formVar.title) {
      return "Title is required";
    }
  }
  const lessonPriceValid = () => {
    if (!formVar.livePrice) {
      return "Video Price is required";
    }
  }
  const examPriceValid = () => {
    if (!formVar.examPrice) {
      return "Test Price is required";
    }
  }
  const publishValid = () => {
    if (!formVar.publishDate) {
      return "Publish Date is Required";
    }
  }

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Are you sure you want to delete the live lessons?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(deleteLiveLessons(data._id))
        }
      });
  }

  const handleDeleteRecording = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Are you sure you want to delete the MP4 file from the server? This cannot be recovered.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then(async (result) => {
        if (result.value) {
          try {
            await service.deleteLiveClassRecording(data._id);
            SweetAlert.fire('Deleted!', 'The MP4 recording file has been deleted from the server.', 'success');
            dispatch(getliveLessons(formVar.limit, formVar.offset, mainId));
          } catch (error) {
            SweetAlert.fire('Error!', error?.response?.data?.message || 'Failed to delete file', 'error');
          }
        }
      });
  }

  const onNavigate = (data) => {
    navigate('/live-questions/' + layoutURL + '?id=' + data._id)
  }


  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">
              </Col>
              <Col md="4">
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Lessons
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Questions</th>
                  <th scope='col'>Live Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.liveLessonsData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td >{item.title}</td>
                    <td >{item.liveQuestions.length}</td>
                    <td >{item.liveStatus.toUpperCase()}</td>


                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer bg-light-primary font-success action-icon'>
                          <i className="fa fa-book fa-lg" onClick={() => onNavigate(item)}></i>
                          <div className="tooltipCustom">Questions</div>
                        </div>
                        {item.liveStatus === 'ended' && item.liveRecordMp4Url && item.liveRecordMp4Url.endsWith('.mp4') && (
                          <>
                            <div
                              className='cursor-pointer bg-light-success font-success action-icon'
                              onClick={() => window.open(item.liveRecordMp4Url, '_blank')}
                            >
                              <i className="fa fa-download fa-lg"></i>
                              <div className="tooltipCustom">Download MP4</div>
                            </div>
                            <button
                              className='btn btn-xs'
                              style={{ 
                                padding: '4px 8px', 
                                fontSize: '11px', 
                                fontWeight: 600, 
                                height: '30px', 
                                display: 'flex', 
                                alignItems: 'center',
                                background: '#fdf2f2',
                                color: '#ec5f5f',
                                border: '1px solid #fbd5d5',
                                borderRadius: '4px',
                                transition: 'all 0.2s'
                              }}
                              onClick={() => handleDeleteRecording(item)}
                            >
                              Delete MP4
                            </button>
                          </>
                        )}
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalliveLessons <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalliveLessons > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalliveLessons}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} size={'lg'}>
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Title</Label>
            <Input className="form-control" type="text" placeholder='Enter Title' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value }))} value={formVar.title} />
            {submit && titleValid() ? <span className='d-block font-danger'>{titleValid()}</span> : ""}
            <Row>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Lesson Price</Label>
                <Input className="form-control" type="text" placeholder='Enter Lesson Price (0 For Free)' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, livePrice: e.target.value }))} value={formVar.livePrice} />
                {submit && lessonPriceValid() ? <span className='d-block font-danger'>{lessonPriceValid()}</span> : ""}
              </Col>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Test Price</Label>
                <Input className="form-control" type="text" placeholder='Enter Test Price (0 For Free)' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, examPrice: e.target.value }))} value={formVar.examPrice} />
                {submit && examPriceValid() ? <span className='d-block font-danger'>{examPriceValid()}</span> : ""}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label className="col-form-label mt-3">Select Date & Time</Label>
                <DatePicker
                  selected={formVar.publishDate ? new Date(formVar.publishDate) : null}
                  onChange={(publishDate) => setFormVar((prevFormVar) => ({ ...prevFormVar, publishDate }))}
                  showTimeSelect
                  dateFormat="Pp"
                  className="form-control"
                  minDate={new Date()}
                  filterTime={(time) => {
                    const selectedDate = moment(formVar.publishDate);
                    const now = moment();
                    return selectedDate.isAfter(now.clone().startOf("day")) || moment(time).isSameOrAfter(now);
                  }}
                />
                {submit && publishValid() ? <span className='d-block font-danger'>{publishValid()}</span> : ""}
              </Col>
              <Col md={6}>
                <Label className="col-form-label mt-3">Class Duration(in minutes)</Label>
                <Input className="form-control" type="text" placeholder='Enter Duration in minutes' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, duration: e.target.value }))} value={formVar.duration} />
              </Col>
            </Row>
            {formVar.liveStatus ==="ended" &&
            <Col >
              <Label className="col-form-label mt-3">Recorded Url</Label>
                <Input className="form-control" type="text" placeholder='Enter recorded url' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, liveRecordUrl: e.target.value }))} value={formVar.liveRecordUrl} />
            </Col>
            }
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default LiveLessonsTable;
